/* SIX PACK — portada: tres discos grandes en 3D (WebGL, three.js).
   Acto 1: MOVE, FUEL y MIND flotan y giran como ruedas, cada uno a su ritmo.
   Acto 2: ruedan hasta alinearse en una sola pila (el sistema).
   Acto 3: se separan rodando y quedan uno al lado del otro: los tres pilares.
   Cámara fija, scroll suavizado con resorte y giro acoplado al desplazamiento (ruedan de verdad).
   Los discos nunca invaden la zona de los textos ni la del menú. */
import * as THREE from "https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.min.js";

(function main() {
  var hero = document.getElementById("hero4");
  if (!hero) return;
  var stick = hero.querySelector(".stick");
  var c2d = hero.querySelector("canvas");
  var labels = [].slice.call(hero.querySelectorAll(".plabel"));
  var isMob = window.innerWidth < 820;

  var renderer;
  try {
    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: "high-performance" });
  } catch (e) { return; }
  if (!renderer.getContext()) return;

  var css = document.createElement("style");
  css.textContent =
    ".hero4{height:400vh}@media (max-width:820px){.hero4{height:380vh}}" +
    ".hero4 canvas.gl{position:absolute;inset:0;width:100%;height:100%;display:block;opacity:0;transition:opacity 1.4s cubic-bezier(.2,.7,.2,1)!important}" +
    "html.gl3d .hero4 canvas.gl{opacity:1}" +
    "html.gl3d .hero4 .meter{display:none}" +
    ".hero4 svg.lead{position:absolute;inset:0;width:100%;height:100%;pointer-events:none;overflow:visible}" +
    ".hero4 .fade3{position:absolute;left:0;right:0;bottom:0;height:52%;pointer-events:none;background:linear-gradient(to top,rgba(7,16,29,.92) 0%,rgba(7,16,29,.6) 45%,rgba(7,16,29,0) 100%)}" +
    ".hero4 .grain{position:absolute;inset:-60%;pointer-events:none;opacity:.06;mix-blend-mode:overlay;animation:spgrain .9s steps(6) infinite!important;z-index:2}" +
    "@keyframes spgrain{0%{transform:translate(0,0)}20%{transform:translate(-7%,4%)}40%{transform:translate(5%,-6%)}60%{transform:translate(-3%,7%)}80%{transform:translate(6%,2%)}100%{transform:translate(0,0)}}";
  document.head.appendChild(css);

  var cv = renderer.domElement;
  cv.className = "gl";
  cv.setAttribute("aria-hidden", "true");
  c2d.parentNode.insertBefore(cv, c2d.nextSibling);
  c2d.style.display = "none";

  var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("class", "lead"); svg.setAttribute("aria-hidden", "true");
  var leads = [0, 1, 2].map(function () {
    var g = document.createElementNS(svg.namespaceURI, "g");
    var l = document.createElementNS(svg.namespaceURI, "polyline");
    l.setAttribute("fill", "none"); l.setAttribute("stroke", "#B8925A"); l.setAttribute("stroke-width", "1");
    var c = document.createElementNS(svg.namespaceURI, "circle");
    c.setAttribute("r", "2.6"); c.setAttribute("fill", "#B8925A");
    g.appendChild(l); g.appendChild(c); svg.appendChild(g);
    return { g: g, l: l, c: c };
  });
  cv.parentNode.insertBefore(svg, cv.nextSibling);
  // Velo inferior: los textos siempre se leen
  var fade = document.createElement("div"); fade.className = "fade3"; fade.setAttribute("aria-hidden", "true");
  svg.parentNode.insertBefore(fade, svg.nextSibling);

  var gc = document.createElement("canvas"); gc.width = gc.height = 160;
  var gx = gc.getContext("2d"), gid = gx.createImageData(160, 160);
  for (var i = 0; i < gid.data.length; i += 4) { var v = Math.random() * 255; gid.data[i] = gid.data[i + 1] = gid.data[i + 2] = v; gid.data[i + 3] = 255; }
  gx.putImageData(gid, 0, 0);
  var grain = document.createElement("div");
  grain.className = "grain"; grain.setAttribute("aria-hidden", "true");
  grain.style.backgroundImage = "url(" + gc.toDataURL() + ")";
  stick.appendChild(grain);

  /* ---------- render y luz ---------- */
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, isMob ? 1.75 : 2));
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.1;
  renderer.setClearColor(0x000000, 0);

  var scene = new THREE.Scene();
  var D = 5;
  var camera = new THREE.PerspectiveCamera(30, 1, 0.1, 60);
  camera.position.set(0, 0, D);

  (function studio() {
    var s = new THREE.Scene();
    s.add(new THREE.Mesh(new THREE.BoxGeometry(24, 14, 24), new THREE.MeshBasicMaterial({ color: 0x08111d, side: THREE.BackSide })));
    function box(w, h, col, k, p) {
      var m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({ color: new THREE.Color(col).multiplyScalar(k), side: THREE.DoubleSide }));
      m.position.set(p[0], p[1], p[2]); m.lookAt(0, 0, 0); s.add(m);
    }
    box(7, 4.5, 0xfff0dc, 7, [-8, 4, 5]);
    box(1.4, 9, 0xd8e4ff, 5, [8, 1, -4]);
    box(10, 1.6, 0xffffff, 3.2, [0, 9, 0]);
    box(4, 2, 0xc9a36b, 1.8, [2, -5, 7]);
    box(3, 6, 0x9fb4d8, 1.4, [-2, 2, -9]);
    box(2, 5, 0xffe2bd, 3, [9, 2, 6]);
    var pm = new THREE.PMREMGenerator(renderer);
    scene.environment = pm.fromScene(s, 0.035).texture;
    pm.dispose();
  })();
  var key = new THREE.DirectionalLight(0xffe7c8, 2.2); key.position.set(-3, 3, 4); scene.add(key);
  var rim = new THREE.DirectionalLight(0xbfd2ff, 1.5); rim.position.set(3, 1.5, -4); scene.add(rim);

  /* ---------- texturas ---------- */
  function speckle() {   // grano fino del caucho
    var c = document.createElement("canvas"); c.width = c.height = 256;
    var x = c.getContext("2d"), d = x.createImageData(256, 256);
    for (var k = 0; k < d.data.length; k += 4) { var n = 110 + Math.random() * 60; d.data[k] = d.data[k + 1] = d.data[k + 2] = n; d.data[k + 3] = 255; }
    x.putImageData(d, 0, 0);
    var t = new THREE.CanvasTexture(c); t.wrapS = t.wrapT = THREE.RepeatWrapping; t.repeat.set(10, 3);
    return t;
  }
  var sansFamily = (getComputedStyle(document.documentElement).getPropertyValue("--sans") || "").trim() || "system-ui, sans-serif";
  function ringText(text, ink, sizePx) {
    var S = 1024, c = document.createElement("canvas"); c.width = c.height = S;
    var x = c.getContext("2d");
    x.translate(S / 2, S / 2);
    x.fillStyle = ink;
    x.font = "600 " + sizePx + "px " + sansFamily;
    x.textAlign = "center"; x.textBaseline = "middle";
    var R = S * 0.442, chars = text.split(""), total = 0, widths = chars.map(function (ch) { var w = x.measureText(ch).width + sizePx * 0.32; total += w; return w; });
    var ang = -Math.PI / 2 - (total / R) / 2;
    chars.forEach(function (ch, i) {
      var a = ang + widths[i] / 2 / R;
      x.save(); x.rotate(a + Math.PI / 2); x.fillText(ch, 0, -R); x.restore();
      ang += widths[i] / R;
    });
    var t = new THREE.CanvasTexture(c); t.colorSpace = THREE.SRGBColorSpace; t.anisotropy = 8;
    return t;
  }

  /* ---------- materiales ---------- */
  var sp = speckle();
  var M = {
    chrome: new THREE.MeshPhysicalMaterial({ color: 0xdfe3e8, metalness: 1, roughness: 0.12, side: THREE.DoubleSide }),
    steel: new THREE.MeshPhysicalMaterial({ color: 0xbfc4cb, metalness: 1, roughness: 0.3 }),
    brass: new THREE.MeshPhysicalMaterial({ color: 0xc8a165, metalness: 1, roughness: 0.24 })
  };
  function rubber(hex) {
    return new THREE.MeshPhysicalMaterial({ color: hex, metalness: 0, roughness: 0.62, bumpMap: sp, bumpScale: 0.35, clearcoat: 0.3, clearcoatRoughness: 0.5, sheen: 0.3, sheenRoughness: 0.6, sheenColor: new THREE.Color(0x8aa0c0) });
  }

  /* ---------- geometría del disco ---------- */
  function arc(pts, cx, cy, r, a0, a1, n) {
    for (var k = 0; k <= n; k++) { var a = a0 + (a1 - a0) * k / n; pts.push(new THREE.Vector2(cx + Math.cos(a) * r, cy + Math.sin(a) * r)); }
  }
  function plateGeo(r, t) {
    var h = t / 2, hr = h * 0.74, ri = 0.09, f = Math.min(0.006, t * 0.12), p = [], V = function (a, b) { p.push(new THREE.Vector2(a, b)); };
    V(ri, -hr); V(r * 0.66, -hr);
    arc(p, r * 0.66, -hr + 0.004, 0.004, -Math.PI / 2, -Math.PI / 4, 3);
    V(r * 0.79, -h + 0.002); V(r - f, -h);
    arc(p, r - f, -h + f, f, -Math.PI / 2, 0, 6);
    arc(p, r - f, h - f, f, 0, Math.PI / 2, 6);
    V(r * 0.79, h - 0.002);
    arc(p, r * 0.66, hr - 0.004, 0.004, Math.PI / 4, Math.PI / 2, 3);
    V(r * 0.66, hr); V(ri, hr); V(ri, -hr);
    var g = new THREE.LatheGeometry(p, isMob ? 96 : 144);
    g.rotateZ(-Math.PI / 2);
    return g;
  }
  function lathe(points, seg) {
    var g = new THREE.LatheGeometry(points.map(function (q) { return new THREE.Vector2(q[0], q[1]); }), seg || 64);
    g.rotateZ(-Math.PI / 2);
    return g;
  }
  var insertG = lathe([[0.0252, -0.5], [0.093, -0.5], [0.093, 0.5], [0.0252, 0.5], [0.0252, -0.5]], 64);
  var boltG = new THREE.CylinderGeometry(0.0052, 0.0052, 0.003, 6); boltG.rotateZ(Math.PI / 2);
  var ringG = new THREE.TorusGeometry(0.0915, 0.0016, 8, 96); ringG.rotateY(Math.PI / 2);

  var TYPES = [
    { r: 0.225, t: 0.062, col: 0x14253c, ink: "#E9DDC6", txt: "SIX PACK  —  MOVE  —  25 KG  —  THE METHOD  —", fs: 30 },
    { r: 0.19, t: 0.05, col: 0x1b1e23, ink: "#C9A36B", txt: "SIX PACK  —  FUEL  —  15 KG  —  MAKE IT SIMPLE  —", fs: 34 },
    { r: 0.152, t: 0.04, col: 0xe6dccb, ink: "#14253C", txt: "SIX PACK  —  MIND  —  10 KG  —", fs: 40 }
  ];
  TYPES.forEach(function (T) {
    T.geo = plateGeo(T.r, T.t);
    T.mat = rubber(T.col);
    T.dm = new THREE.MeshPhysicalMaterial({ map: ringText(T.txt, T.ink, T.fs), transparent: true, metalness: T.ink === "#C9A36B" ? 0.9 : 0.1, roughness: 0.45, side: THREE.DoubleSide, depthWrite: false, polygonOffset: true, polygonOffsetFactor: -2 });
    T.dg = new THREE.CircleGeometry(T.r, 96);
  });
  function makePlate(T) {
    var g = new THREE.Group(), spin = new THREE.Group(); g.add(spin);
    spin.add(new THREE.Mesh(T.geo, T.mat));
    var ins = new THREE.Mesh(insertG, M.chrome); ins.scale.x = T.t; spin.add(ins);
    [-1, 1].forEach(function (f) {
      var rg = new THREE.Mesh(ringG, M.brass); rg.position.x = f * (T.t * 0.4 + 0.0006); spin.add(rg);
      for (var b = 0; b < 6; b++) {   // seis tornillos: el guiño a "six pack"
        var bo = new THREE.Mesh(boltG, M.steel), a = b / 6 * Math.PI * 2;
        bo.position.set(f * (T.t * 0.4 + 0.0015), Math.cos(a) * 0.062, Math.sin(a) * 0.062); spin.add(bo);
      }
      var d = new THREE.Mesh(T.dg, T.dm);
      d.rotation.y = f > 0 ? Math.PI / 2 : -Math.PI / 2;
      d.position.x = f * (T.t / 2 + 0.0006);
      if (f < 0) d.scale.x = -1;
      spin.add(d);
    });
    scene.add(g);
    return { g: g, spin: spin, T: T };
  }

  // Tres discos: MOVE, FUEL, MIND
  var P = [0, 1, 2].map(function (k) { var pl = makePlate(TYPES[k]); pl.k = k; pl.ang = [0, 2.1, 4.2][k]; pl.px = null; return pl; });

  /* ---------- composición en coordenadas de pantalla ----------
     nx, ny: centro en pantalla (-1 a 1); z: profundidad; R: radio visible en fracción de media altura;
     yaw / pitch: giro del disco para mostrar su espesor. */
  var LAY = {
    d: {
      A: [{ nx: 0.25, ny: 0.33, z: 0, R: 0.42, yaw: -0.5, pitch: 0.1 }, { nx: 0.68, ny: 0.45, z: -1.4, R: 0.32, yaw: -0.62, pitch: 0.14 }, { nx: -0.2, ny: 0.5, z: -2.4, R: 0.27, yaw: -0.42, pitch: 0.16 }],
      B: { nx: 0.36, ny: 0.16, R: 0.5, yaw: -1.02, pitch: 0.16 },
      C: { nx: 0.22, ny: 0.2, R: 0.46, yaw: -0.74, pitch: 0.12 }
    },
    // Celular: zona libre entre el menú (arriba) y los textos (abajo)
    m: {
      A: [{ nx: -0.05, ny: 0.2, z: 0, R: 0.3, yaw: -0.45, pitch: 0.1 }, { nx: 0.45, ny: 0.54, z: -1.4, R: 0.2, yaw: -0.6, pitch: 0.14 }, { nx: -0.45, ny: 0.55, z: -2.4, R: 0.19, yaw: -0.4, pitch: 0.16 }],
      B: { nx: 0, ny: 0.3, R: 0.34, yaw: -1.02, pitch: 0.16 },
      C: { nx: -0.38, ny: 0.3, R: 0.27, yaw: -0.74, pitch: 0.12 }
    }
  };

  var W = 0, H = 0, hh = 1, hw = 1;
  function size() {
    var w = stick.clientWidth, h = stick.clientHeight;
    if (w === W && Math.abs(h - H) < 2) return;
    W = w; H = h; isMob = W < 820;
    renderer.setSize(W, H, false);
    camera.aspect = W / H; camera.fov = isMob ? 34 : 30;
    camera.updateProjectionMatrix();
    hh = D * Math.tan(camera.fov * Math.PI / 360); hw = hh * camera.aspect;
  }
  window.addEventListener("resize", size);
  window.addEventListener("orientationchange", function () { setTimeout(size, 250); });
  size();

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function sstep(a, b, x) { var t = clamp((x - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function progress() {
    var r = hero.getBoundingClientRect(), h = r.height - window.innerHeight;
    return h <= 0 ? (r.top <= 0 ? 1 : 0) : clamp(-r.top / h, 0, 1);
  }

  // Estado en mundo de un disco para una pose de pantalla
  function pose(o, s) {
    var k = (D - o.z) / D;   // lo que está más lejos ocupa menos pantalla
    s.x = o.nx * hw * k; s.y = o.ny * hh * k; s.z = o.z; s.r = o.R * hh * k; s.yaw = o.yaw; s.pitch = o.pitch;
    return s;
  }
  function stack(B, i, s) {   // pila coaxial: MOVE atrás, FUEL, MIND delante
    var sc = B.R * hh / TYPES[0].r, x0 = 0;
    for (var j = 0; j < i; j++) x0 += (TYPES[j].t * 0.5 + TYPES[j + 1].t * 0.5 + 0.004) * sc;
    var ax = new THREE.Vector3(1, 0, 0).applyEuler(new THREE.Euler(B.pitch, B.yaw + Math.PI / 2, 0, "YXZ"));
    var o = -(x0 - 0.055 * sc);   // MIND (el más pequeño) queda adelante
    s.x = B.nx * hw + ax.x * o; s.y = B.ny * hh + ax.y * o; s.z = ax.z * o;
    s.r = TYPES[i].r * sc; s.yaw = B.yaw; s.pitch = B.pitch;
    return s;
  }

  var px = 0, py = 0, tx = 0, ty = 0;
  window.addEventListener("pointermove", function (e) { if (e.pointerType === "mouse") { tx = e.clientX / window.innerWidth - 0.5; ty = e.clientY / window.innerHeight - 0.5; } }, { passive: true });

  var onScreen = true;
  if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; }).observe(hero);

  var sA = {}, sB = {}, sC = {}, wv = new THREE.Vector3();
  var ps = progress(), last = performance.now(), t0 = last, started = false;
  var SPD_A = [0.42, -0.34, 0.5], SPD_C = [0.22, 0.22, 0.22];

  function frame(now) {
    requestAnimationFrame(frame);
    if (!onScreen) { last = now; return; }
    var dt = Math.min((now - last) / 1000, 0.05); last = now;
    var t = (now - t0) / 1000;
    // Resorte: el scroll se sigue con suavidad, sin saltos
    ps += (progress() - ps) * (1 - Math.exp(-dt * 5.5));
    var L = isMob ? LAY.m : LAY.d;
    var wAB = sstep(0.14, 0.34, ps), wBC = sstep(0.6, 0.82, ps);

    P.forEach(function (pl, i) {
      pose(L.A[i], sA); stack(L.B, i, sB); stack(L.C, i, sC);
      var x = lerp(lerp(sA.x, sB.x, wAB), sC.x, wBC);
      var y = lerp(lerp(sA.y, sB.y, wAB), sC.y, wBC);
      var z = lerp(lerp(sA.z, sB.z, wAB), sC.z, wBC);
      var r = lerp(lerp(sA.r, sB.r, wAB), sC.r, wBC);
      var yaw = lerp(lerp(sA.yaw, sB.yaw, wAB), sC.yaw, wBC);
      var pitch = lerp(lerp(sA.pitch, sB.pitch, wAB), sC.pitch, wBC);
      // flotación suave (se calma cuando están en pila)
      var calm = 1 - wAB * (1 - wBC);
      y += Math.sin(t * 0.55 + i * 2.1) * 0.025 * hh * calm;
      x += Math.cos(t * 0.4 + i * 1.7) * 0.012 * hw * calm;
      // entrada al cargar: ruedan desde la derecha, uno tras otro
      var ti = sstep(0, 1, (t - 0.1 - i * 0.18) / 1.9);
      x += (1 - ti) * (hw * 1.6);
      // giro: velocidad propia + rodado real según el desplazamiento horizontal
      var w = lerp(lerp(SPD_A[i], 0.28, wAB), SPD_C[i], wBC);
      if (pl.px !== null) pl.ang -= (x - pl.px) / Math.max(r, 0.05);
      pl.ang += w * dt; pl.px = x;
      var s = r / pl.T.r;
      pl.g.position.set(x, y, z);
      pl.g.scale.setScalar(s);
      pl.g.rotation.set(pitch, yaw + Math.PI / 2, 0, "YXZ");
      pl.spin.rotation.x = pl.ang;
    });

    // Cámara: leve paralaje con el mouse y respiración
    px += (tx - px) * 0.04; py += (ty - py) * 0.04;
    camera.position.set(px * 0.35 + (isMob ? Math.sin(t * 0.3) * 0.06 : 0), -py * 0.2 + Math.sin(t * 0.45) * 0.02, D);
    camera.lookAt(0, 0, 0);
    renderer.render(scene, camera);
    if (!started) {
      started = true; document.documentElement.classList.add("gl3d"); window.SP3D = true;
      if (window.SPBarbell) window.SPBarbell.prototype.draw = function () {};
    }

    // Etiquetas MOVE / FUEL / MIND: columna a la derecha de la pila, cada una unida a su disco
    var la = sstep(0.84, 0.93, ps), col = 0, an = [];
    P.forEach(function (pl, k) {
      var g = pl.g;
      wv.copy(g.position).project(camera);
      var cx = (wv.x * 0.5 + 0.5) * W, cy = (-wv.y * 0.5 + 0.5) * H;
      wv.set(g.position.x, g.position.y + pl.T.r * g.scale.x, g.position.z).project(camera);
      var rp = Math.abs((-wv.y * 0.5 + 0.5) * H - cy), a = [0.95, 0.25, -0.55][k];
      an[k] = [cx + rp * Math.cos(a), cy - rp * Math.sin(a)];
      col = Math.max(col, cx + rp);
    });
    col += isMob ? 22 : 56;
    P.forEach(function (pl, k) {
      var el = labels[k], ld = leads[k], ax = an[k][0], ay = an[k][1];
      ld.l.setAttribute("points", ax + "," + ay + " " + (col - 8) + "," + ay);
      ld.c.setAttribute("cx", ax); ld.c.setAttribute("cy", ay);
      ld.g.style.opacity = la;
      if (el) {
        el.style.opacity = la;
        var ex = clamp(col, 12, W - el.offsetWidth - 8);
        el.style.transform = "translate3d(" + Math.round(ex) + "px," + Math.round(ay - 10) + "px,0)";
      }
    });
  }
  requestAnimationFrame(frame);
})();
